<template>
    <div id="loading">
        <img class="img" src="@/assets/img/loading.svg" alt="loading..."/>
    </div>
</template>

<script>
export default {

};
</script>

<style scoped>
/* Loading */
#loading {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(5px);
    /* position: absolute;
    z-index: 1000;
    background-color: white;
    height: 100vh;
    width: 100vw;
    text-align: center;
    line-height: 100vh; */
}

.img {
    display: block;
    margin-bottom: auto;
    margin-top: 20%;
    margin-left: auto;
    margin-right: auto;
    width: 200px;
    height: 200px;
}
</style>